// removed by extract-text-webpack-plugin
module.exports = {"Background":"_9RUQYWroFrn304b-BZMht","Background-collapsed":"B5atfw8ufUOrElfq2FVhi","Wrapper":"cDQByK1y3Ps6dZuuQwfxj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/BlockingModal/BlockingModal.css
// module id = 524
// module chunks = 0